// src/components/Navbar.js
import { useState } from 'react';

import useResponsiveFlags from '../hooks/useResponsiveFlags';
import { translations } from '../locales/lang';
import useLanguage from '../hooks/useLanguage';
import LanguageSelector from './LanguageSelector';
import styles from '../assets/styles/NavBar.module.css';

export default function Navbar() {
    const { isMobile } = useResponsiveFlags();
    const [menuOpen, setMenuOpen] = useState(false);
    const { language, changeLanguage } = useLanguage();



    const toggleMenu = () => setMenuOpen(!menuOpen);

    const onClickItem = (id) => {
        const element = document.getElementById(id);
        if (element) {
            isMobile && toggleMenu();
            const offset = 72;
            const top = element.getBoundingClientRect().top + window.scrollY - offset;

            window.scrollTo({
                top,
                behavior: 'smooth'
            });
        }
    };
    return (
        <nav className={styles.navbar}>
            <div className={styles.navbarLeft}>
                <img src="/images/logo.svg" alt="Logo" width={81} height={'auto'} />
            </div>
            <div className={styles.navbarRight}>
                {/* Desktop menu */}
                {!isMobile && (
                    <ul className={styles.navbarMenu}>
                        <li><a onClick={() => onClickItem('introduce')}>{translations[language].navbar.introduce}</a></li>
                        <li><a onClick={() => onClickItem('solution')}>{translations[language].navbar.solution}</a></li>
                        <li><a onClick={() => onClickItem('feature')}>{translations[language].navbar.feature}</a></li>
                        <li><a onClick={() => onClickItem('contact')}>{translations[language].navbar.contact}</a></li>
                        <li><a onClick={() => onClickItem('device')}>{translations[language].navbar.download}</a></li>
                        <li> <a onClick={() => window.open('https://dtp.i-school.vn/', '_blank')}>{translations[language].navbar.login}</a></li>
                        <li>
                            {/* <select
                                className={styles.languageSelect}
                                value={language}
                                onChange={(e) => changeLanguage(e.target.value)}
                            >
                                <option value="vi">
                                    <img src='/images/vn-flag.svg' alt='vn' width={24} height={24} /> Tiếng Việt
                                </option>
                                <option value="en">
                                    <img src='/images/en-flag.svg' alt='en' width={24} height={24} /> English
                                </option>
                            </select> */}
                            <LanguageSelector />
                        </li>
                    </ul>
                )}

                {/* Mobile button ☰ */}
                {isMobile && (
                    <div className={styles.hamburger} onClick={toggleMenu}>
                        ☰
                    </div>
                )}
            </div>

            {/* Mobile full-screen menu */}
            {isMobile && (
                <div className={`${styles.mobileMenu} ${menuOpen ? styles.open : styles.close}`}>
                    <div className={styles.menuHeader}>
                        <img src="/images/logo.svg" alt="Logo" width={81} />
                        <span className={styles.closeIcon} onClick={toggleMenu}>✕</span>
                    </div>
                    <ul className={styles.menuList}>
                        <li><a onClick={() => onClickItem('introduce')}>{translations[language].navbar.introduce}</a></li>
                        <li><a onClick={() => onClickItem('solution')}>{translations[language].navbar.solution}</a></li>
                        <li><a onClick={() => onClickItem('feature')}>{translations[language].navbar.feature}</a></li>
                        <li><a onClick={() => onClickItem('contact')}>{translations[language].navbar.contact}</a></li>
                        <li><a onClick={() => onClickItem('device')}>{translations[language].navbar.download}</a></li>
                        <li> <a onClick={() => {
                            toggleMenu();
                            window.open('https://dtp.i-school.vn/', '_blank');
                        }}>{translations[language].navbar.login}</a></li>
                        <li>
                            {/* <div className={styles.mobileLangSelector}>
                                <select
                                    value={language}
                                    onChange={(e) => changeLanguage(e.target.value)}
                                >
                                    <option value="vi"><img src='/images/vn-flag.svg' alt='vn' /> Tiếng Việt</option>
                                    <option value="en"><img src='/images/en-flag.svg' alt='en' /> English</option>
                                </select>
                            </div> */}
                            <LanguageSelector />
                        </li>
                    </ul>
                    {/* <div className={styles.langSelector}>
                        <span>Ngôn ngữ</span>
                        <ul>
                            <li><img src="/images/vietnam.svg" alt="VN" /> Tiếng Việt ✔</li>
                            <li><img src="/images/english.svg" alt="EN" /> English</li>
                        </ul>
                    </div> */}
                </div>
            )
            }
        </nav >
    );
}
